import type { ReactNode } from "react";
import { PRODUCT } from "@/lib/product";
import type { HealthResponse } from "../../shared/api";

export type VersionInfo = Pick<HealthResponse, "version" | "build">;

/** Sayfa altbilgisi: "Sürüm 0.1.1 · abc1234"; build yoksa yalnız sürüm (#376). */
export function VersionFooter({ info }: { info?: VersionInfo | null }) {
  if (!info) return null;
  return <footer data-slot="version" className="px-6 py-3 text-xs text-muted-foreground">Sürüm {info.version}{info.build && ` · ${info.build}`}</footer>;
}

/** Giriş ve parola belirleme düzeni (ui.md §12.14): solda koyu lacivert marka paneli, sağda `bg-card` üzerinde form. */
export function AuthLayout({ company, version, children }: { company?: string | null; version?: VersionInfo | null; children: ReactNode }) {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <aside className="flex flex-col justify-center gap-6 bg-sidebar p-8 text-sidebar-foreground lg:p-16">
        <div className="flex items-center gap-3">
          <span aria-hidden="true" className="flex size-10 items-center justify-center rounded-lg bg-sidebar-primary text-lg font-semibold text-sidebar-primary-foreground">Y</span>
          <div>
            <p className="text-lg font-semibold leading-tight text-sidebar-accent-foreground">{PRODUCT}</p>
            {company && <p className="text-sm text-sidebar-muted">{company}</p>}
          </div>
        </div>
        <p className="hidden max-w-sm text-lg lg:block">Dört sistemin dosyalarını birleştirir, mutabakatı ve kanıtı tek yerde tutar.</p>
      </aside>
      <div className="flex flex-col bg-card">
        <main className="flex flex-1 items-center justify-center p-6">
          <div className="flex w-full max-w-sm flex-col gap-6">{children}</div>
        </main>
        <VersionFooter info={version} />
      </div>
    </div>
  );
}
